import React, { useEffect, useCallback, memo } from 'react';
import { connect } from 'react-redux';

import config from '../../config';
import { isResearcher } from '../../utils/checkPermissions';
import { showError } from '../../utils/MessagePopup';
import connectOptions, { mergeProps } from '../../utils/connectOptions';
import { CompanyExecutive } from '../../components/Company/CompanyExecutive';
import { usePopupContext } from '../../contexts/PopupContext';

const CompanyExecutiveContainer = props => {
  const { openPopup, closePopup } = usePopupContext();

  const hasAccess = useCallback(() => {
    if (!props.user) return false;

    return !isResearcher(props.user.getIn(['roles', 0, 'slug'], null));
  }, [props.user]);

  const handleDoubleClickRow = useCallback(row => {
    window.open(`/contact/${row.data.contactId}`, '_blank');
  }, []);

  useEffect(() => {
    if (!hasAccess()) {
      showError(openPopup, config.permisionError, () => {
        props.history.push('/');
        closePopup();
      });
    }
  }, [hasAccess, openPopup, closePopup, props.history]);

  if (!hasAccess()) return null;

  return (
    <div className="tab-pane active full-height" id="slide-3">
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 p0 full-height">
        <CompanyExecutive executive={props.executive} onDoubleClickRow={handleDoubleClickRow} />
      </div>
    </div>
  );
};

export { CompanyExecutiveContainer };
export default connect(
  state => ({
    executive: state.targetCompany.executive,
    user: state.auth.get('user', null),
  }),
  {},
  mergeProps,
  connectOptions,
)(memo(CompanyExecutiveContainer));
